import { Component, input, output } from '@angular/core';
import { AbstractControl, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatChipGrid,
  MatChipInput,
  MatChipInputEvent,
  MatChipRemove,
  MatChipRow
} from '@angular/material/chips';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { AppTooltipComponent } from '../app-tooltip/app-tooltip.component';
import { DialogFormErrorComponent } from '../dialog-form-error/dialog-form-error.component';

@Component({
  selector: 'app-dialog-chip-input',
  imports: [
    FormsModule,
    MatChipGrid,
    MatChipInput,
    MatChipRemove,
    MatChipRow,
    MatFormField,
    MatIcon,
    MatLabel,
    ReactiveFormsModule,
    AppTooltipComponent,
    DialogFormErrorComponent
  ],
  templateUrl: './dialog-chip-input.component.html'
})
export class DialogChipInputComponent {
  label = input<string>();
  ctrl = input.required<AbstractControl>();
  hint = input<string>();
  marginBottom = input<string>();

  removeItem = output<string>();
  addItem = output<string>();

  getControl(): FormControl<string[]> {
    return this.ctrl() as FormControl<string[]>;
  }

  remove(item: string) {
    this.removeItem.emit(item);
  }

  add(event: MatChipInputEvent) {
    this.addItem.emit(event.value);

    event.chipInput.clear();
  }

  addOnInputBlur(event: FocusEvent): void {
    const input = event.target as HTMLInputElement;
    this.addItem.emit(input.value);
    input.value = '';
  }
}
